/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminBookingListClientDto } from './AdminBookingListClientDto';
import type { AdminBookingListExpertDto } from './AdminBookingListExpertDto';
export type AdminBookingListItemDto = {
    id: string;
    bookingId: string;
    client: AdminBookingListClientDto;
    service: string;
    package?: Record<string, any> | null;
    sessions: string;
    expert: AdminBookingListExpertDto;
    /**
     * When the booking was placed (bookings.booked_at), as an ISO instant
     */
    dateTime: string;
    /**
     * Same instant as dateTime; kept for callers that render date and time separately
     */
    time: string;
    mode: string;
    amount: string;
    status: AdminBookingListItemDto.status;
    /**
     * "Resolved" or "1 Open", "2 Open", etc.
     */
    disputeStatusLabel?: Record<string, any> | null;
    bookingType: AdminBookingListItemDto.bookingType;
};
export namespace AdminBookingListItemDto {
    export enum status {
        PENDING = 'Pending',
        UPCOMING = 'Upcoming',
        COMPLETED = 'Completed',
        CANCELLED = 'Cancelled',
        REFUNDED = 'Refunded',
        DISPUTED = 'Disputed',
    }
    export enum bookingType {
        PACKAGE = 'package',
        SESSION = 'session',
    }
}

